import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobepremiereproComponent } from './simple-icons-adobepremierepro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobepremiereproComponent ],
    exports:      [ SimpleIconsAdobepremiereproComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobepremiereproModule {}
